// src/routes/inventoryRoutes.jsx
import React from 'react';
import { Route } from 'react-router-dom';
import Warehouses from '../pages/warehouses/Warehouses';
import Inventory from '../pages/inventory/Inventory';
import Movements from '../pages/inventory/Movements';
import ProtectedRoute from '../components/global/ProtectedRoute';

const inventoryRoutes = (
    <>
        <Route
            path="/warehouses"
            element={
                <ProtectedRoute requiredPermission="inventory.manage">
                    <Warehouses />
                </ProtectedRoute>
            }
        />
        <Route
            path="/inventory"
            element={
                <ProtectedRoute requiredPermission="inventory.manage">
                    <Inventory />
                </ProtectedRoute>
            }
        />
        <Route
            path="/inventory/movements"
            element={
                <ProtectedRoute requiredPermission="inventory.manage">
                    <Movements />
                </ProtectedRoute>
            }
        />
    </>
);

export default inventoryRoutes;
